import React from "react";
import {
    Input,
    DataTable,
    Container,
  } from "@airbus/components-react";

 /*****
 * 
 * Table Component
 * props:
 * - columns: exemple
 * [         
        { Header: "Nom", accessor: "name", width: 180 },
        { Header: "Prénom", accessor: "firstname", width: 180 },
        { Header: "mail", accessor: "usermail", width: 250 },
        { Header: "role", accessor: "userrole", minWidth:350, maxWidth: 550 }
    ];
 * - data : exemple
    [
        {
        name:'gioan',
        firstname:'Christophe',
        usermail:'christophegioan@gmail.com',
        userrole:'admin'
        }
    ]
 */


class TableComponent extends React.Component {

    constructor(props){
        super();

        this.columns = props.columns;

        /*this.columns = [
            {
                
                header: "Début évenement",
                accessorKey: "start_date",
                width: 170
            },
            {
                
                header: "Fin évenement",
                accessorKey: "end_date",
                width: 170
            },
            {
                
                header: "Titre",
                accessorKey: "title",
                width: 150
            },
            {
                
                header: "Journée entière",
                accessorKey: "all_day",
                width: 120
            },
            {
                
                header: "Statut",
                accessorKey: "status",
                width: 100
            },
            {
                
                header: "Date publication",
                accessorKey: "date",
                width: 170
            },
            {
                id:"action",
                accessorKey: "id",
                width: 70
            }
        ]*/

        //debugger;
        this.data=props.data;

        if(this.data === null){
            this.data = [];
        }

        this.filtered_data = props.data; //default filtering is all data

        if(this.filtered_data === null){
            this.filtered_data = [];
        }

        //States
        this.state={
            data: this.filtered_data
        }
        console.log(this.state);


    }


    componentWillReceiveProps(props){
        this.data=props.data;

        if(this.data === null){
            this.data = [];
        }

        this.filtered_data = props.data; //default filtering is all data

        if(this.filtered_data === null){
            this.filtered_data = [];
        }

        //States
        this.setState({data: this.filtered_data})

        console.log(this.state);
        
    }

    /**
     * RENDERING
     * @returns dom
     */
    render() { return(
        <div>
            <Container>
                <Input style={{width:'150px'}} placeholder="Rechercher" onChange={this.handleChangeSearch}/>
                
                <DataTable allowResize  columns={this.columns} data={this.filtered_data}  defaultRowsPerPage={9} condensed/>
                
            </Container>
            
        </div>
    )}

    /***********/
    /*EVENTS   */ 
    /***********/

    //Handle on change search input box
    handleChangeSearch=(event) =>{
        const value = event.target.value;

        //Filter Data Table
        let _ = require('underscore');
        let filtered_data = _.filter(this.data,function(item){

            let found=false;
            Object.keys(item).forEach(function(key) {
                debugger;
                if (item[key] === undefined){
                    /*skip undefined keys*/
                }
                
                else if(!isNaN(item[key]) || !isNaN(value) ){
                    
                    
                    if(item[key].toString().includes(value.toString())===true){
                        found = true;

                    }
                }
                else if(item[key].toString().toLowerCase().includes(value.toLowerCase())===true){
                    found = true;
                }
                
            });
            return found === true;

        });

        this.filtered_data=filtered_data; //update filtered data    

        if (this.filtered_data.length > 0){
            this.setState({data: filtered_data})
        }else{
            this.setState({data: []})
        }


        
    }

}

export default TableComponent;